// src/cnp_story.ts
var getStory = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/stories/${id}`, options).json();
};
var searchStories = (client, provider) => async (query, options) => {
  return await client.get(`${provider}/stories/${query}`, options).json();
};
var createStoryApi = (client, provider) => {
  return {
    getStory: getStory(client, provider),
    searchStories: searchStories(client, provider)
  };
};

export {
  createStoryApi
};
